import NProgress from 'nprogress'

NProgress.configure({ showSpinner: false })

export default {
  state: {
    apiWaitingCount: 0,
    methodsInProgress: []
  },

  mutations: {
    ADD_METHOD_IN_PROGRESS(state, method) {
      state.methodsInProgress.push(method)
    },

    REMOVE_METHOD_IN_PROGRESS(state, method) {
      state.methodsInProgress = state.methodsInProgress.filter(methodInProgress => methodInProgress !== method)
    }
  },

  getters: {
    isMethodInProgress: state => method => {
      return state.methodsInProgress.includes(method)
    }
  },

  actions: {
    startLoading ({ state, commit }, method) {
      commit('ADD_METHOD_IN_PROGRESS', method)
      if (state.apiWaitingCount === 0) {
        NProgress.start()
      }
      state.apiWaitingCount++
    },
    doneLoading ({ state, commit }, method) {
      commit('REMOVE_METHOD_IN_PROGRESS', method)
      state.apiWaitingCount--
      if (state.apiWaitingCount === 0) {
        NProgress.done()
      }
    }
  }
}
